import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class MicrotaskService {
  
get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }  
  constructor(private http: HttpClient) { }
  getPlantsData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetDepartments', data);
  }
  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetGroup', data);
  }
  getFTEMicroTasksData(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'getmicrotask', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'MicroTask/getAllMicrotask', data);
    
  }
  addFTEMicroTasksData(data: any): Observable<any> {
    // return this.http.post<any>(this.baseUrl + 'insertmicrotask', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'MicroTask/insertmicrotask', data);
  }
}
